import { Avatar, Group, Menu, useMantineTheme } from "@mantine/core";
import { OpenFormProps, useOpenForm } from "@mcurros2/microm";
import { IconUserScan } from "@tabler/icons-react";

export interface LoggedInMenuProps {
    loggedInUser?: string,
    initials?: string,
    photoURL?: string,
    enabledMenus?: Set<string>,
    onLogOut: () => Promise<void>,
    onEditProfile: (openform: (props: OpenFormProps) => Promise<void>) => Promise<void>
}

export function LoggedInMenu({ loggedInUser, initials, enabledMenus, onLogOut, photoURL, onEditProfile }: LoggedInMenuProps) {

    const theme = useMantineTheme();

    const openform = useOpenForm();

    const hasBackoffice = enabledMenus ? [...enabledMenus].some((menu) => menu.startsWith("BackofficeMenu_")) : false;
    const hasClientesHome = enabledMenus ? [...enabledMenus].some((menu) => menu.startsWith("ClientesHomeMenu_")) : false;


    return (
        <Group>
            <Menu withArrow>
                <Menu.Target>
                    <Avatar src={photoURL || null} alt={loggedInUser} radius="xl" color="red"
                        style={{
                            border: (theme.colorScheme === 'dark') ? `2px solid ${theme.colors.dark[0]}` : `2px solid ${theme.colors.dark[9]}`
                        }}
                    >{photoURL ? undefined : initials}</Avatar>
                </Menu.Target>
                <Menu.Dropdown>
                    {hasBackoffice &&
                        <>
                            <Menu.Item icon={<IconUserScan size="1rem" />} onClick={async () => {
                                await onEditProfile(openform);
                            }}>
                                Editar perfil
                            </Menu.Item>
                            <Menu.Divider />
                        </>
                    }
                    <Menu.Item onClick={async () => {
                        await onLogOut();
                    }}>
                        Cerrar sesión
                    </Menu.Item>
                </Menu.Dropdown>
            </Menu>
        </Group>
    )
}